module.exports = __webpack_public_path__ + "media/images/story/typo/congratsCute-d684217e5aa971ef1b7f29b9677de947.svg";